<template>
  <div class="home_information_added">
    <div class="gdlr-core-pbf-wrapper " style="padding: 0px 0px 0px 0px;">
      <div class="gdlr-core-pbf-background-wrap"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
        <div
          class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container"
        >
          <div
            class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js "
              style="padding: 75px 0px 0px 0px;"
              data-aos="zoom-in"
              data-aos-duration="3000"
              data-aos-delay="300"
            >
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js ">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-image-item gdlr-core-item-pdlr gdlr-core-item-pdb  gdlr-core-center-align"
                  >
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image  gdlr-core-image-item-style-round"
                      style="border-width: 0px;"
                    >
                      <img
                        :src="
                          announcement &&
                          announcement[0] &&
                          announcement[0].image != null
                            ? announcement[0].image
                            : require('@/assets/images/template4/hp-donation-400x212.jpg')
                        "
                        width="700"
                        height="372"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr"
                  >
                    <div class="gdlr-core-title-item-title-wrap clearfix">
                      <h3
                        class="gdlr-core-title-item-title gdlr-core-skin-title "
                        style="font-size: 22px ;font-weight: 700 ;letter-spacing: 0px ;text-transform: none ;color: #182847 ;"
                      >
                        {{
                          announcement &&
                            announcement[0] &&
                            announcement[0].title
                        }}
                      </h3>
                    </div>
                    <span
                      class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                      style="font-size: 15px ;font-style: normal ;margin-top: 14px ;"
                      v-html="
                        announcement && announcement[0] && announcement[0].body
                      "
                    ></span>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                  >
                    <router-link
                      class="gdlr-core-button  gdlr-core-button-solid gdlr-core-button-no-border"
                      :to="
                        `/pengumuman-detail/${announcement &&
                          announcement[0] &&
                          announcement[0].url}`
                      "
                      style="font-size: 13px ;letter-spacing: 0px ;padding: 17px 31px 18px 31px;text-transform: none ;border-radius: 2px;-moz-border-radius: 2px;-webkit-border-radius: 2px;"
                      ><span class="gdlr-core-content"
                        >Selengkapnya</span
                      ></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ekstrakurikuler gdlr-core-pbf-column gdlr-core-column-30">
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js "
              style="margin: 0px 20px 0px 0px;padding: 0px 25px 20px 25px;"
            >
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <h3
                  class="gdlr-core-title-item-title gdlr-core-skin-title "
                  style="font-size: 22px ;font-weight: 700 ;letter-spacing: 0px ;text-transform: none ;color: #182847 ;"
                >
                  Ekstrakurikuler
                </h3>
                <div class="row">
                  <div
                    class="col-6 image_ekstra"
                    v-for="(ekstra, index) in extracurricular.slice(0, 6)"
                    :key="index"
                    data-aos="fade-in"
                    :data-aos-duration="index + `000`"
                    :data-aos-delay="index + `00`"
                  >
                    <router-link :to="`/ekstra-kurikuler-detail/${ekstra.url}`">
                      <img
                        class="img-fluid"
                        :src="
                          ekstra && ekstra.image != null
                            ? ekstra.image
                            : require('@/assets/images/template4/hp-donation-400x212.jpg')
                        "
                        alt=""
                      />
                      <span>
                        {{ ekstra.title }}
                      </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "announcement",
  props: ["announcement", "extracurricular"],

  methods: {
    formattedDate(date) {
      moment.locale("id");
      return moment(date).format("DD MMMM YYYY HH:MM");
    },
    formattedDateDay(date) {
      moment.locale("id");
      return moment(date).format("DD");
    },
    formattedDateMonth(date) {
      moment.locale("id");
      return moment(date).format("MMM");
    },
    formattedClock(date) {
      moment.locale("id");
      return moment(date).format("HH:MM");
    },
  },
};
</script>
